module.exports = __webpack_public_path__ + "img/ico-created-on.4b251ed9.svg";